module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('equip-table', {
    attrs: {
      "title": "Own Power",
      "title-heading": "h4",
      "site-id": this.siteId,
      "site-data": _vm.siteData,
      "owner-id": this.ownerId,
      "show-qr-code": _vm.showQrCode,
      "filter-col": "category",
      "filter-val": "Power"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c5dc814"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/subcat/UtilEquipTable.vue
// module id = 1417
// module chunks = 0